import type { MissingFileKeyHelpRequest } from '@/types/fileKey/FileKeyFacilitation';

export abstract class FileKeyFacilitationService {
  abstract getMissingFileKeyRequests(): Promise<MissingFileKeyHelpRequest[]>;
}
